// 解约协议
import fetch,{ postFrom, getBlob} from '../utils/fetch';


export function getSignedText(params) {
  return fetch({
    method: 'GET',
    url: 'surrender/preview/getSignedText',
    params
  })
}


// 获取查询条件
export function getConditions() {
  return fetch({
      method: 'GET',
      url: 'surrender/getConditions'
  })
}

//查询解约协议列表 
export function surrenderList(params) {
  return fetch({
      method: 'GET',
      url: 'surrender/surrenderList',
      params
  })
}

// 关闭解约协议 
export function closeSurrenderProtocol(surrenderFid) {
  return postFrom('surrender/closeSurrenderProtocol', {surrenderFid:surrenderFid});
}

// 获取解约信息详情
export function getSurrenderInfo(surrenderFid) {
  return fetch({
      method: 'GET',
      url: 'surrender/getSurrenderInfo',
      params:{
        surrenderFid
      }
  })
}

// 企业交割详情 
export function getEnterpriseDeliverys(params) {
  return fetch({
      method: 'GET',
      url: 'surrender/getEnterpriseDeliverys',
      params
  })
}

// 个人解约交割详情 
export function getSurrenderDeliverys(params) {
  return fetch({
      method: 'GET',
      url: 'surrender/getSurrenderDeliverys',
      params
  })
}
//  企业结算明细 
export function getEnterpriseBalance(params) {
  return fetch({
      method: 'GET',
      url: 'surrender/getEnterpriseBalance',
      params
  })
}

// 个人／企业房间结算明细
export function getSurrenderCostItem(params) {
  return fetch({
      method: 'GET',
      url: 'surrender/getSurrenderCostItem',
      params
  })
}

// 解约审核
export function confirmSurrAudit(data) {
  return fetch({
      method: 'POST',
      url: 'surrender/confirmSurrAudit',
      data
  })
}

//  导出解约协议
export function downloadSurrenderList(data) {
  return getBlob({
    method: 'POST',
    url: 'surrender/downloadSurrenderList',
    data
  })
}

// 解约协议数量查询 
export function checkSurrenderCount(data) {
  return fetch({
    method:'POST',
    url:'surrender/downloadSurrenderListCount',
    data
  })
}
